import { render, staticRenderFns } from "./JobEvaluation.vue?vue&type=template&id=72af37e2&scoped=true&"
import script from "./JobEvaluation.vue?vue&type=script&lang=js&"
export * from "./JobEvaluation.vue?vue&type=script&lang=js&"
import style0 from "./JobEvaluation.vue?vue&type=style&index=0&id=72af37e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72af37e2",
  null
  
)

export default component.exports